var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#88A0B1",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 -1L12.11 -1",
    transform: "matrix(1 0 0 -1 .52 10.142)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#88A0B1",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M21.057 1.778L1.52 1.778M12.63 21.433L1.521 21.433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#88A0B1",
    strokeWidth: 2,
    d: "M25.894 14.805l-2.853 4.042h12.127l-4.28-6.063-3.21 4.547-1.784-2.526z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.074,
    height: 18.37,
    x: 18.187,
    y: 6.407,
    stroke: "#88A0B1",
    strokeWidth: 2,
    rx: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.36c1e9f2f92316cb8c0b4895d753ef73.svg";
export { ForwardRef as ReactComponent };